<div class="container-fluid p-0 login-Container">
        <div class="XeniusLogo">
        </div>
        <div class="bulb">
        </div>
        <div class="login-card login-dark">
          <div>
            <div class="login-main"> 
              <div class="theme-form">
                <h4>Reset Your Password</h4>
                <form class="PhoneNumber" *ngIf="!HideNumber" [formGroup]="resetForm">
                  <div class="form-group" >
                    <label class="col-form-label">
                      <span ></span>
                    </label>
                    <div class="row">
                      <!-- <div class="col-4 col-sm-3">
                        <input class="form-control mb-1 pl-0 pr-0" style="padding:10px !important;" formControlName="countryCode"  type="text" value="+ 91">
                      </div> -->
                      <div class="col-12 col-sm-12">
                        <input class="form-control mb-1" formControlName="UserName"  type="text" placeholder="Enter Your User Name">
                      </div>
                      <div class="col-12">
                        <div class="text-end mt-3">
                          <button class="btn w-100" type="button" (click)="sendOTP()" [disabled]="!resetForm.valid">Send</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="resetForm.valid" class="mt-4 mb-4"><span class="reset-password-link text-white ">If don't receive OTP ?  <a class="btn-link text-danger cursor-pointer"  (click)="resendOtp()">
                    {{ counter > 0 ? 'Resend OTP in ' + counter + 's' : 'Resend OTP' }}
                  </a></span></div>
                </form>
                <form class="otp" *ngIf="this.OTPInput" [formGroup]="otpForm">
                  <div class="row">
                    <div class="col" *ngFor="let i of [0,1,2,3]">
                      <input
                        #otpInput
                        class="form-control text-center opt-text"
                        style="padding:10px !important;"
                        [formControlName]="'otp' + i"
                        type="text"
                        maxlength="1"
                        (input)="moveToNext($event, i)"
                      />
                    </div>
                  </div>
                </form>
                <div class="theme-form">
                  <form class="new_password" [formGroup]="passwordForm">
                    <div *ngIf="this.SetPassword">
                      <h6 class="mt-4">Create Your Password</h6>
                      
                      <!-- New Password Field -->
                      <div class="form-group">
                        <label class="col-form-label">New Password</label>
                        <div class="form-input position-relative">
                          <input 
                            class="form-control" 
                            formControlName="newPassword" 
                            [type]="show ? 'text' : 'password'" 
                            placeholder="New Password"
                          >
                          
                          <div class="text mt-1" style="color: #f6b53e;
  font-weight: 600;" *ngIf="passwordForm.controls['newPassword'].hasError('minlength')">
                            Minimum 3 characters required
                          </div>
                          <div class="text mt-1" style="color: #f6b53e;
  font-weight: 600;" *ngIf="passwordForm.controls['newPassword'].hasError('maxlength')">
                            Maximum 20 characters allowed
                          </div>
                          <div class="text mt-1" style="color: #f6b53e;
  font-weight: 600;" *ngIf="passwordForm.controls['newPassword'].hasError('pattern')">
                            Password must contain at least 1 letter, 1 number, and 1 special character (&#64;$!%*?&)
                          </div>
                   
                          <!-- Toggle Password Visibility -->
                          <span class="passwordimage" (click)="showPassword()" *ngIf="show">
                            <img src="\assets\fonts\flag-icon\Eye.svg" alt="Eye" width="24" height="24">
                          </span>
                          <span class="passwordimage" (click)="showPassword()" *ngIf="!show">
                            <img src="\assets\fonts\flag-icon\eyeO.svg" alt="Eye" width="24" height="24">
                          </span>
                        </div>
                      </div>
                  
                      <!-- Confirm Password Field -->
                      <div class="form-group">
                        <label class="col-form-label">Retype Password</label>
                        <input 
                          class="form-control" 
                          formControlName="confirmPassword" 
                          [type]="show ? 'text' : 'password'" 
                          placeholder="*********"
                        >
                        
                        <!-- Validation Messages -->
                        <div class="text mt-1" style="color: #f6b53e;
  font-weight: 600;" *ngIf="passwordForm.controls['confirmPassword'].hasError('minlength')">
                          Minimum 3 characters required
                        </div>
                        <div class="text mt-1" style="color: #f6b53e;
  font-weight: 600;" *ngIf="passwordForm.controls['confirmPassword'].hasError('maxlength')">
                          Maximum 20 characters allowed
                        </div>
                        <div class="text mt-1" style="color: #f6b53e;
  font-weight: 600;" *ngIf="passwordForm.controls['confirmPassword'].hasError('pattern')">
                          Password must contain at least 1 letter, 1 number, and 1 special character (&#64;$!%*?&)
                        </div>
                        <div class="text mt-1" style="color: #f6b53e;
  font-weight: 600;" *ngIf="passwordForm.hasError('passwordsMismatch')">
                          Passwords do not match
                        </div>
                      </div>
                  
                      <!-- Submit Button -->
                      <div class="form-group mb-0 text-end mt-3">
                        <button [disabled]="!passwordForm.valid" class="btn w-100" type="button" (click)="resetPassword()">
                          Done
                        </button>
                      </div>
                    </div>
                  </form>
                  
                  
                </div>
                <p class="mt-4 mb-0 text-center">Already have an password?
                  <a class="btn-link ms-2 text-danger" [routerLink]="['/auth/login']">Sign in</a></p>
                </div>
            </div>
          </div>
        </div>
      </div>


